import { Device } from 'app/container/TradeIn/interface';

const formatAndSortTradeInPayload = (payload: Device[]) => {
    return payload
        .map(device => ({id: device.id, text: device.name}))
        .sort((deviceA, deviceB) => deviceA.text.localeCompare(deviceB.text));
};

export default formatAndSortTradeInPayload;
